export default __webpack_public_path__ + "static/media/home-corporate-img-01.e33a4fe5.jpg";